import styled from 'styled-components'

export const DadosArquivos = styled.div`

`

DadosArquivos.Acao = styled.div`
    display: inline;
    position: relative;
    float: left;
    cursor: pointer;
    height: 30px;
    width: 30px;
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 5px;
`

DadosArquivos.NomeArquivo = styled.div`        
    padding-top: 9px;
`

DadosArquivos.ListaArquivos = styled.div`
    background-color: #ebebeb;
    height: 35px;
    text-align: justify;    
`

DadosArquivos.Body = styled.div`
    
`

DadosArquivos.Header = styled.div`
    font-size: 20px;
`